import script from "./EUserCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./EUserCard.vue?vue&type=script&setup=true&lang=ts"

import "./EUserCard.vue?vue&type=style&index=0&id=49347ada&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49347ada"]])

export default __exports__